<template>
    <!--获取意向度-->
    <el-select class="ele-select"  :disabled="disabled" :value-key="type=='object'?'dicCode':''" :clearable="clearable" :size="size" @visible-change="visiblechange" @change="change" :value="value" :placeholder="placeholder">
        <el-option
                v-for="item in list"
                :key="item.dicCode"
                :label="item.dicName"
                :value="type=='object'?item:item.dicCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "want-level",
        props:{
            size:String,
            placeholder:String,
            clearable:Boolean,
            value:Object|String,
            disabled:Boolean,
            type:String//是对象还是字符串
        },
        model:{
            prop:'value',
            event:'input'
        },
        data(){
            return{
                list:[],
                // value:''
            }
        },
        watch:{
            value(newval,oldval){
                var code=this.type=='object'?newval.dicCode:newval;
                var list=this.list.filter((item)=>item.dicCode==code);
                //数据不存在时
                if(list.length==0){
                    this.$store.state.dicChange=true;
                    this.getData();
                }

            }
        },
        mounted(){
            this.getData();
        },
        methods:{
            getData(){
                if(this.$root.getStorage('dic')){
                    this.list=this.$root.getStorage('dic').filter((item)=>item.dicType=='want_level');
                }else{
                    this.$store.state.dicChange=true;
                }
            },

            visiblechange(isshow){
                if(isshow){
                    // this.getData();
                }
            },
            change(value){
                console.log(value)
                this.$emit('input',value)
            }
        }

    }
</script>

<style scoped>

</style>